const neighborhood = (state) => state;

export default {
    neighborhood,
};
